"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _partial3 = _interopRequireDefault(require("lodash-es/partial"));

var _noop3 = _interopRequireDefault(require("lodash-es/noop"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fontIcon = _interopRequireDefault(require("../../atoms/font-icon"));

var _styles = require("./_styles");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AccordionItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(AccordionItem, _PureComponent);

  function AccordionItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AccordionItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AccordionItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "isItemActive", function () {
      var _this$props = _this.props,
          activeIndices = _this$props.activeIndices,
          value = _this$props.value;
      return activeIndices.indexOf(value) > -1;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleHeight", function () {
      var isActiveItem = _this.isItemActive();

      var height = 0;

      if (isActiveItem) {
        height = _this.contentRef.scrollHeight;
      }

      _this.contentRef.style.maxHeight = "".concat(height, "px");
    });

    _defineProperty(_assertThisInitialized(_this), "getContentRef", function (element) {
      _this.contentRef = element;
    });

    return _this;
  }

  _createClass(AccordionItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.toggleHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      this.toggleHeight();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          bordered = _this$props2.bordered,
          title = _this$props2.title,
          value = _this$props2.value,
          renderer = _this$props2.renderer,
          version = _this$props2.version,
          onClick = _this$props2.onClick,
          disabled = _this$props2.disabled;
      var isActiveItem = this.isItemActive();
      return _react["default"].createElement(_styles.AccordionItemWrapper, {
        version: version,
        bordered: bordered
      }, _react["default"].createElement(_styles.AccordionTitle, {
        version: version
      }, _react["default"].createElement(_styles.AccordionButton, {
        view: "plain",
        disabled: disabled,
        onClick: (0, _partial3["default"])(onClick, value)
      }, _react["default"].createElement(_fontIcon["default"], null, isActiveItem ? 'icon-expand_less' : 'icon-expand_more')), _react["default"].createElement(_styles.AccordionHeading, {
        size: 3
      }, title), renderer()), _react["default"].createElement(_styles.AccordionContentWrapper, {
        innerRef: this.getContentRef,
        isOpen: isActiveItem
      }, _react["default"].createElement(_styles.AccordionContent, null, children)));
    }
  }]);

  return AccordionItem;
}(_react.PureComponent);

AccordionItem.displayName = 'AccordionItem';
AccordionItem.propTypes = {
  /** Content */
  children: _propTypes["default"].node,

  /** unique value for each item */
  value: _propTypes["default"].number.isRequired,

  /** title to display */
  title: _propTypes["default"].string.isRequired,

  /** Any content that goes after the header */
  renderer: _propTypes["default"].func,

  /** disable the item */
  disabled: _propTypes["default"].bool
};
AccordionItem.defaultProps = {
  renderer: _noop3["default"],
  disabled: false
};
var _default = AccordionItem;
exports["default"] = _default;